var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumnGridIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "columns-03",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "columns-03-2",
    "data-name": "columns-03",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.908.218a2,2,0,0,1,.874.874A4.969,4.969,0,0,1,12,3.2V8.8a4.969,4.969,0,0,1-.218,2.108,2,2,0,0,1-.874.874A4.969,4.969,0,0,1,8.8,12H3.2a4.969,4.969,0,0,1-2.108-.218,2,2,0,0,1-.874-.874A4.969,4.969,0,0,1,0,8.8V3.2A4.969,4.969,0,0,1,.218,1.092,2,2,0,0,1,1.092.218,4.969,4.969,0,0,1,3.2,0H8.8a4.969,4.969,0,0,1,2.108.218Z",
    transform: "translate(2 2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon-2",
    "data-name": "Icon",
    d: "M4,0V12M8,0V12",
    transform: "translate(2 2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnGridIconGray);
export default __webpack_public_path__ + "static/media/columnGridIconGray.4fb7cefe871458a5588aa56a6fc741c8.svg";
export { ForwardRef as ReactComponent };